import React, { useState, useEffect } from "react";
import styles from "./TemplateHero25.module.css";

const TemplateHero25 = ({ branding, heroData }) => {
  const [current, setCurrent] = useState(0);
  const [animIn, setAnimIn] = useState(true);

  const slides = heroData?.slides || [];

  useEffect(() => {
    if (slides.length <= 1) return;

    const t = setInterval(() => {
      setAnimIn(false);

      setTimeout(() => {
        setCurrent((p) => (p + 1) % slides.length);
        setAnimIn(true);
      }, 450);
    }, 5000);

    return () => clearInterval(t);
  }, [slides.length]);

  if (!slides.length) return null;

  return (
    <div className={styles.root}>
      {/* LEFT SIDE */}
      <div className={styles.left}>
        <div className={`${styles.corner} ${styles.cornerTL}`} />
        <div className={`${styles.corner} ${styles.cornerBR}`} />

        <div className={styles.meta}>
          <div className={styles.metaLine} />
          <span className={styles.metaText}>
            {branding?.companyName || "Travel Co."}
          </span>
        </div>

        <h1
          className={`${styles.title} ${
            animIn ? styles.animIn : styles.animOut
          }`}
        >
          {slides[current].title}
        </h1>

        <p className={styles.sub}>{slides[current].subtitle}</p>

        <div className={styles.actions}>
          <button className={styles.btnPrimary}>Book a Trip</button>
          <button className={styles.btnLink}>Packages →</button>
        </div>

        <div className={styles.stats}>
          <div>
            <span className={styles.statNum}>200+</span>
            <span className={styles.statLbl}>Destinations</span>
          </div>

          <div>
            <span className={styles.statNum}>15k+</span>
            <span className={styles.statLbl}>Happy Travelers</span>
          </div>

          <div>
            <span className={styles.statNum}>98%</span>
            <span className={styles.statLbl}>Satisfaction</span>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className={styles.right}>
        <div className={styles.imgFrame}>
          <div className={styles.imgShadow} />

          {slides.map((s, i) => (
            <div
              key={i}
              className={styles.img}
              style={{
                backgroundImage: `url('${s.image}')`,
                opacity: i === current ? 1 : 0,
              }}
            />
          ))}

          <div className={styles.imgLabel}>Featured Journey</div>

          <div className={styles.strip}>
            {slides.map((_, i) => (
              <div
                key={i}
                className={`${styles.stripDot} ${
                  i === current ? styles.activeDot : ""
                }`}
                onClick={() => setCurrent(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateHero25;